import { makeStyles } from '@mui/styles'
import {
  MyAccountTheme,
  MyAccountMiniWidgetModalClasses,
} from '@dxp-module/themes'

const miniWidgetModalStyles = makeStyles<
  MyAccountTheme,
  Record<string, never>,
  MyAccountMiniWidgetModalClasses
>(
  theme => ({
    closeContainer: {
      color: theme.palette.common.white,
      zIndex: 100,
      backgroundColor: theme.palette.primary.main,
      display: 'flex',
      justifyContent: 'space-between',
      padding: 0,
      alignItems: 'center',
    },
    closeIcon: {
      width: 40,
      height: 40,
      fill: theme.palette.common.white,
    },
    title: {
      lineHeight: '33px',
      display: 'inline-block',
      padding: '16px',
      color: theme.palette.common.white,
      fontWeight: 'normal',
    },
    icon: {
      fill: theme.palette.common.white,
    },
    content: {
      whiteSpace: 'pre-wrap',
      overflowY: 'auto',
      height: 'auto',
      paddingTop: '30px',
    },
    modalRoot: {},
    closeButton: {},
    formTitle: {
      display: 'none',
    },
    subTitleSecondary: {},
  }),
  { name: 'MyAccount_MiniWidgetModal' }
)

export default miniWidgetModalStyles
